import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=731a5766&scoped=true"
import script from "./Tabla.vue?vue&type=script&lang=ts"
export * from "./Tabla.vue?vue&type=script&lang=ts"
import style0 from "./Tabla.vue?vue&type=style&index=0&id=731a5766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a5766",
  null
  
)

export default component.exports